import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ActionPlanRuleService } from 'utility'
import { AutoRulesBtn, RuleCountBadge } from './styles'
import { parseRuleCountResponse } from './utils'

export const AutoRulesButton = ({
    templateId,
    templateNumericId,
    templateName,
}) => {
    const navigate = useNavigate()
    const [count, setCount] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        let cancelled = false
        const load = async () => {
            const countId = templateNumericId ?? templateId
            if (!countId) {
                setLoading(false)
                return
            }
            try {
                const result =
                    await ActionPlanRuleService.getRuleCount(countId)
                if (!cancelled) {
                    const { total } = parseRuleCountResponse(result)
                    setCount(total)
                }
            } catch {
                if (!cancelled) setCount(0)
            } finally {
                if (!cancelled) setLoading(false)
            }
        }
        load()
        return () => {
            cancelled = true
        }
    }, [templateId, templateNumericId])

    const handleClick = () => {
        const base = `/app/templates/${templateId}/auto-rules`
        const navState = { templateName, templateNumericId }
        if (count === 0) {
            navigate(`${base}/create`, { state: navState })
        } else {
            navigate(base, { state: navState })
        }
    }

    return (
        <AutoRulesBtn
            type="button"
            onClick={handleClick}
            disabled={loading}
            title="Set up automatic ticket creation for this template"
        >
            ⚙ Auto Rules
            <RuleCountBadge $none={!count}>
                {loading ? '…' : count ?? 0}
            </RuleCountBadge>
        </AutoRulesBtn>
    )
}
